import * as SectionHeaderStyles from "./section-header.module.css"

import React from "react"

type SectionHeaderProps = {
    title: string
    icon: string
}

const SectionHeader = ({ icon, title }: SectionHeaderProps) => {
    return (
        <div className={SectionHeaderStyles.header}>
            <i className="lavita-icon">{icon}</i>
            <div>{title}</div>
        </div>
    )
}

export default SectionHeader
